import { uid } from '@/firebase'
import { UserActivityStatus } from '@/helpers/fs/userActivityStatus'
import { FSUserActivityStatus } from '@WombatTechnology/nitte-time-lib'
import { defineStore } from 'pinia'
type State = {
  data: FSUserActivityStatus | null
}

export const useActivityStatusStore = defineStore('userActivityStatus', {
  state: (): State => {
    return {
      data: null
    }
  },
  actions: {
    async setup() {
      this.sync('data', UserActivityStatus.doc(uid()!))
    }
  },
  getters: {
    wasIntroductionShown(state) {
      return state.data?.wasIntroductionShown
    }
  }
})
